import Vue from 'vue';
import Hammer from "hammerjs"; // Touch-events library
import scrollama from 'scrollama';

Vue.component("image-text-block-slider", {
    /**
     * Vue.js component properties.
     *
     * @type {Array}
     */
    props: ['slides'],

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            // hammertime: null,
            activeSlide: 1,
            transition: "slide-out-up",
            view: "slider",
            // hoverSlide: false,
            // slides: [1, 2, 3]
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        document.body.classList.add("collection");

        // this.loadSwipeEvents();
        // document.addEventListener("keyup", this.keyEvents);

    },

    /**
     * Vue.js instance 'destroyed' hook.
     *
     * @type {Object}
     */
    destroyed() {
        document.body.classList.remove("collection");
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        /**
         * Navigate the collection slider to the next slide.
         *
         * @return {void}
         */
        nextSlide() {

            if (this.inTransition) {
                return;
            }

            // Set the next transition, and the current active slide to 'unactive'
            this.transition = "slide-out-up";
            this.inTransition = true;

            // Increment active slide, check if it exits
            this.activeSlide++;
            if (this.activeSlide <= this.slides) {
                return;
            }
            // If not, we jump to the first slide
            this.activeSlide = 1;
            
        },

        /**
         * Navigate the collection slider to the previous slide.
         *
         * @return {void}
         */
        previousSlide() {
            if (this.inTransition) {
                return;
            }
            // Set the previous transition, and the current active slide to 'unactive'
            this.transition = "slide-out-down";
            this.inTransition = true;

            // Decrement active slide, check if it exits
            this.activeSlide--;
            if (this.activeSlide != 0) {
                return;
            }

            // If not, we jump to the last slide
            this.activeSlide = (this.slides);

            
        },
        afterEnter(el) {
            this.inTransition = false;
        },
    },

    /**
     * Vue.beforeDestroy
     *
     * Instance method called before the component is destroyed.
     * Use this method to destroy any living object or events when
     * using page transitions.
     */
    beforeDestroy() {
        this.hammertime.destroy();
        document.removeEventListener("keyup", this.keyEvents);
    },
});
